import { config } from "core/config/app";
import FlavorsPage from "./pages/FlavorsPage";
import RecipesPage from "./pages/RecipesPage";
import RecipeDetailPage from "modules/Recipes/pages/RecipeDetailPage";
import MyKitchen from "./pages/MyKitchen";
import SearchRecipesPage from "modules/Recipes/pages/SearchRecipesPage";

const ROUTES = {
	INGREDIENTS: "INGREDIENTS",
	INGREDIENT_OPTIONS: 'INGREDIENT_OPTIONS',
	INGREDIENT_RECIPES: 'INGREDIENT_RECIPES',
	INGREDIENT_RECIPE_DETAIL: 'INGREDIENT_RECIPE_DETAIL',
}

const router = [
	{
		name: ROUTES.INGREDIENTS,
		auth: true,
		exact: true,
		path: `${config?.basename}/ingredients`,
		element: <MyKitchen />,
		title: "Ingredients",
	},
	{
		name: ROUTES.INGREDIENT_OPTIONS,
		auth: true,
		exact: true,
		path: `${config?.basename}/ingredient/flavor`,
		element: <FlavorsPage />,
		title: "Flavor",
	},
	{
		name: ROUTES.INGREDIENT_RECIPES,
		exact: true,
		path: `${config?.basename}/ingredient/recipes`,
		element: <RecipesPage />,
		title: "Recipe Suggestion List",
	},
	{
		name: ROUTES.INGREDIENT_RECIPE_DETAIL,
		exact: true,
		path: `${config?.basename}/ingredient/recipe/:id`,
		element: <RecipeDetailPage activeIndex={2} />,
		title: "Detailed Recipe",
	},
	{
		name: "SEARCH_RECIPES",
		exact: true,
		path: `${config?.basename}/search-recipes`,
		element: <SearchRecipesPage />,
		title: "Search Recipe api",
	},
];
export default router;
